export default __webpack_public_path__ + "static/media/hover.deac357c.png";